<template>
    <div class="checkout_session" v-if="info.order" :key="isCheckoutPageCount">

        <div class="checkout_header_area ">
            <div class="header_action_icon back_icon" @click="checkoutPageBack()"></div>
            <div class="header_text">
                <span>{{label['checkout_text_header']}}</span>
            </div>
            <div class="header_action_icon"></div>
        </div>

        <div class="checkout_main_area">

            <div class="checkout_main_content_area">
                <div class="checkout_header_div">{{label['checkout_text_header']}}</div>

                <div class="checkout_event_title">{{event.eventTitle}}</div>

                <div class="checkout_event_info">

                    <!--<div class="event_info_tag full mall">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['event_common_text_mall']}}</div>
                                <div class="tag_content_text" v-html="event.mall.mallName"></div>
                            </div>
                        </div>
                    </div>-->

                    <div class="event_info_tag full date">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['event_common_text_date']}}</div>
                                <div class="tag_content_text" v-html="selectEventSessionDateTime"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag full venue">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['event_common_text_venue']}}</div>
                                <div class="tag_content_text" v-html="$root.selectEventLocationDisplay(event.location)" v-if="event.location.length > 0"></div>
                                <div class="tag_content_text" v-html="event.locationDetails" v-if="event.locationDetails != ''"></div>
                                <div class="tag_extra" @click="openHowToGetThere()" v-if="event.howToGetThere != ''">{{label['event_common_text_venue_how_to_get_there']}}</div>

                                <div class="tag_google_map" v-if="event.mettingPointlong != ''">
                                    <div class="tag_google_map_text">{{label['event_details_text_ExternalMeetingPoint']}}</div>
                                    <div class="tag_google_map_btn">
                                        <a :href="$root.writeGoogleMapPath(event.mettingPointlong,event.mettingPointlat)" target="_blank">{{label['event_details_text_GoogleMap']}}</a>
                                    </div>
                                </div>
                                <div class="tag_content_text" v-html="event.mettingPointAddress" v-if="event.mettingPointAddress != ''"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag quantity">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['event_common_text_quantity']}}</div>
                                <div class="tag_content_text" v-html="selectEventQuantity"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag language" v-if="selectEventLanguageDisplay != ''">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['event_common_text_language']}}</div>
                                <div class="tag_content_text" v-html="selectEventLanguageDisplay"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag username">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['checkout_text_username']}}</div>
                                <div class="tag_content_text" v-html="order.memberName"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag phone">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['checkout_text_phoneno']}}</div>
                                <div class="tag_content_text" v-html="order.memberPhone"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag full email">
                        <div class="event_info_tag_inner_div">
                            <div class="tag_icon"></div>
                            <div class="tag_content">
                                <div class="tag_title">{{label['checkout_text_email']}}</div>
                                <div class="tag_content_text" v-html="order.memberEmail"></div>
                            </div>
                        </div>
                    </div>

                    <div class="event_info_tag full">
                        {{label['checkout_text_can_share_ticket_msg']}}
                    </div>

                </div><!-- checkout_event_info end -->

                <!-- coupon with discount code start -->
                <div style="width:100%" v-if="!order.submitWaitingList">
                    <div class="checkout_discountcode" v-if="isCheckoutPage && order.finalPrice > 0">
                        <div class="discountcode_title">
                            {{CouponDiscountCodeLabel()}}
                        </div>
                        <div class="discountcode_checkout_div" v-if="isCheckoutPage" >
                            <div class="discountcode_input_div" :class="{'inUse' : UseDiscountCodeObj.inUse, 'isError' : UseDiscountCodeObj.isError}">
                                <div class="discountcode_input_area">
                                    <input type="text"
                                           :placeholder="CouponDiscountCodeLabel()"
                                           class="form-control"
                                           :class="{'no_coupon' : !info.enableCouponCode}"
                                           id="checkout_cart_discount_code"
                                           autocomplete="off"
                                           v-model="UseDiscountCodeObj.codeUse"
                                           :readonly="UseDiscountCodeObj.inUse || !checkCanUseDiscountCode()" 
                                           v-if="CheckoutSelectCouponLayerObj.use_coupon.length <= 0"/>
                                    <div class="coupon_display_div" v-if="CheckoutSelectCouponLayerObj.use_coupon.length > 0">
                                        <div class="coupon_row"                                             
                                             v-for="(coup, index) in CheckoutSelectCouponLayerObj.use_coupon"
                                             :key="'coup'+index">
                                            {{coup['gtCoupon_Name' + getItemSubfix()]}}
                                        </div>
                                    </div>
                                    <div v-if="info.enableCouponCode" class="coupon_select_icon" @click="OpenOrderCouponEditLayer()" :class="{'disable' : !checkCanUseCoupon()}" :alt="label['checkout_order_use_coupon_header_text']" :title="label['checkout_order_use_coupon_header_text']"></div>
                                </div>
                                <div class="discountcode_btn_area">
                                    <div class="discountcode_btn" v-if="!UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="UseDiscountCodeCheckoutBtnClick()">{{label['checkout_text_discountcode_apply']}}</div>
                                    <div class="discountcode_btn" v-if="UseDiscountCodeObj.inUse && CheckoutSelectCouponLayerObj.use_coupon.length <= 0" @click="RemoveDiscountCodeCheckoutBtnClick()">{{label['checkout_text_discountcode_cancel']}}</div>
                                    <div class="discountcode_btn" v-if="CheckoutSelectCouponLayerObj.use_coupon.length > 0" @click="RemoveCouponUseBtnClick()">{{label['checkout_text_discountcode_cancel']}}</div>
                                </div>
                            </div>
                            <div class="discountcode_invalid_msg" v-if="UseDiscountCodeObj.isError">{{label['checkout_text_discountcode_invalid']}}</div>
                            <div class="discountcode_invalid_msg isSuccess" v-if="UseDiscountCodeObj.inUse">{{label['checkout_text_discountcode_valid']}}</div>
                        </div>
                    </div>
                    <div class="checkout_payment_coupon_area" v-if="!isCheckoutPage && CheckoutSelectCouponLayerObj.use_coupon.length > 0">
                        <div class="checkout_payment_coupon_header_div">{{label['checkout_order_use_coupon_header_text']}}</div>
                        <div class="checkout_payment_coupon_row preview_div" >
                            <div class="coupon_display_div">
                                <div class="coupon_row"
                                     v-for="(coup, index) in CheckoutSelectCouponLayerObj.use_coupon">
                                    {{coup['gtCoupon_Name' + getItemSubfix()]}}<div class="checkout_preview_coupon_remove_icon" @click="CouponRemovePreview(index)"></div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="checkout_discountcode" v-if="!isCheckoutPage && UseDiscountCodeObj.inUse">
                        <div class="discountcode_title">
                            {{label['checkout_text_discountcode']}}
                        </div>
                        <div class="discountcode_preview_div" >
                            <div class="discountcode_value_display_div">
                                {{UseDiscountCodeObj.codeUse}}
                            </div>
                        </div>
                    </div><!-- checkout_discountcode end -->
                </div>
                <!-- coupon with discount code start -->

                <div style="width:100%" v-if="!order.submitWaitingList">
                    <div class="checkout_paymethod" v-if="order.finalPrice > 0">
                        <div class="paymethod_title">{{label['checkout_text_paymethod']}}</div>

                        <div class="paymethod_checkout_div" v-if="isCheckoutPage">
                            <div class="paymethod_select_div">

                                <div class="paymethod_select_tag " 
                                     v-for="(item, index) in payMethodList"
                                     :key="'pm'+index"
                                     @click="setPayMethod(item)"
                                     :class="{selected: item.code == payMethod.code, disable : !checkPayMethodInCoupon(item)}"
                                     >
                                    <div class="paymethod_tick_div">
                                        <div class="paymethod_tick"></div>
                                        <div class="paymethod_name">{{ item["name" + getItemSubfix()] }}</div>
                                    </div>
                                    <div class="paymethod_image">
                                        <img :src="item.image" align="absmiddle" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="paymethod_preview_div" v-if="!isCheckoutPage">
                            <div class="paymethod_select_div">

                                <div class="paymethod_select_tag isPreview">
                                    <div class="paymethod_tick_div">
                                        <div class="paymethod_name">{{ payMethod["name" + getItemSubfix()] }}</div>
                                    </div>
                                    <div class="paymethod_image">
                                        <img :src="payMethod.image" align="absmiddle" />
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div><!-- checkout_paymethod end -->
                </div>


                <div class="checkout_amount">
                    <div class="amount_list_div">

                        <div class="amount_list_row">
                            <div class="amount_name">{{label['event_common_text_original_price']}}</div>
                            <div class="amount_value"><money :price="order.totalPrice" /></div>
                        </div>

                        <div class="amount_list_row"
                             v-for="(discount,index) in order.orderPriceTag.filter((o) => (o.totalDiscount > 0))"
                             :key="'discount'+index">
                            <div class="amount_name">{{$root.writePriceTagName(discount)}} {{label['event_common_text_discounted']}} {{discount.tagDiscount_discount}}% {{label['event_common_text_off']}}</div>
                            <div class="amount_value">-<money :price="discount.totalDiscount" /></div>
                        </div>

                        <div class="amount_list_row" v-if="order.orderCoupon != undefined" 
                             v-for="(coup,index) in order.orderCoupon"
                             :key="'orderCoupon'+index">
                            <div class="amount_name">{{coup['gtCoupon_Name' + getItemSubfix()]}}</div>
                            <div class="amount_value">-<money :price="coup.orderCaculateCouponAmount" /></div>
                        </div>

                        <div class="amount_list_row" v-if="order.orderDiscountCode != undefined" 
                             v-for="(discount,index) in order.orderDiscountCode"
                             :key="'discountCode'+index">
                            <div class="amount_name">{{discount.discountCodeTypeName}}</div>
                            <div class="amount_value">-<money :price="discount.orderCaculateDiscountAmount" /></div>
                        </div>

                        <div class="amount_list_row isBold">
                            <div class="amount_name">{{label['event_common_text_total']}}</div>
                            <div class="amount_value"><money :price="order.finalPrice" /></div>
                        </div>

                    </div>
                </div><!-- checkout_amount end -->


                <div class="checkout_tnc_area" v-if="isCheckoutPage">

                    <div class="tnc_div" :class="{selected : isTickCheckoutTNC}">
                        <div class="tnc_tick" @click="tickCheckoutTNC()"></div>
                        <div class="tnc_message">
                            <span class="tnc_message_a" v-html="label['checkout_text_tnc_message_a']"></span>
                            <span class="tnc_message_b" v-html="label['checkout_text_tnc_message_b']" @click="openCheckoutTNC()"></span>
                            <span class="tnc_message_c" v-html="label['checkout_text_tnc_message_c']"></span>
                        </div>
                    </div>

                    <div class="tnc_bottom_msg_div">
                        {{label['checkout_text_bottom_remind_message']}}
                    </div>

                </div><!-- checkout_tnc_area end -->


                <div class="checkout_submit_btn_area">

                    <div class="submit_btn" :class="{active : checkCanSubmitReturn(false)}" @click="checkoutBookNowClick()">
                        {{(order.finalPrice > 0 ? label['checkout_text_submit_btn_amount'] : label['checkout_text_submit_btn_free'])   }}
                    </div>

                </div><!-- checkout_submit_btn_area end -->


            </div><!-- checkout_main_content_area end -->

        </div>

        <!-- HowToGetThere start -->
        <transition name="slide-up">
            <div class="how_to_get_there_div" v-if="isOpenHowToGetThere" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="how_to_get_there_div_background" @click="closeHowToGetThere()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="how_to_get_there_div_layer">
                    <div class="how_to_get_there_inner_div">
                        <div class="how_to_get_there_top_div">
                            <div class="close_icon" @click="closeHowToGetThere()"></div>
                        </div>
                        <div class="how_to_get_there_middle_div">
                            <div class="header_div">
                                {{label['event_common_text_venue_how_to_get_there_layer_title']}}
                            </div>
                            <div class="body_div">
                               
                                <div class="image_div">
                                    <img :src="event.howToGetThere" align="absmiddle" />
                                </div>
                                <div class="location_div">
                                    <div class="location_icon"></div>
                                    <div class="location_content">
                                        <div class="location_title">
                                            {{label['event_common_text_venue']}}
                                        </div>
                                        <div class="location_content_text" v-html="event.location.locationName" v-if="event.location.locationName != ''"></div>
                                        <div class="location_content_text" v-html="event.locationDetails" v-if="event.locationDetails != ''"></div>
                                    </div>
                                </div>

                            </div>
                        </div>                       
                    </div>

                </div>

            </div>
        </transition>
        <!-- HowToGetThere end

        <!-- checkout tnc start -->
        <transition name="slide-up">
            <div class="tnc_popup_div" v-if="isOpenCheckoutTNC" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="tnc_popup_div_background" @click="closeCheckoutTNC()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="tnc_popup_div_layer">
                    <div class="tnc_popup_inner_div">
                        <div class="tnc_popup_top_div">
                            <div class="close_icon" @click="closeCheckoutTNC()"></div>
                        </div>
                        <div class="tnc_popup_middle_div">
                            <div class="header_div">
                                {{label['checkout_text_tnc_header']}}
                            </div>
                            <div class="body_div">                               
                                <div class="body_content" v-html="checkoutTNCContent"></div>                               
                            </div>
                        </div>                       
                    </div>

                </div>

            </div>
        </transition>
        <!-- checkout tnc end -->



        <!-- checkout select coupon layer start -->
        <transition name="slide-up">
            <div class="checkout_select_coupon_layer" v-if="CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer" :style="{'height':$root.full_screen_height.height_fix}">
                <div class="checkout_select_coupon_layer_background" @click="CloseOrderCouponEditLayer()" :style="{'height':$root.full_screen_height.height_fix}"></div>

                <div class="checkout_select_coupon_layer_div">
                    <div class="checkout_select_coupon_layer_inner_div">
                        <div class="checkout_select_coupon_layer_header_area">
                            <div class="checkout_select_coupon_layer_close_btn" @click="CloseOrderCouponEditLayer()"></div>
                        </div>
                        <div class="checkout_select_coupon_layer_info_area">
                            <div class="header_div">
                                {{label['checkout_order_use_coupon_layer_header_text']}}
                            </div>
                            <div class="checkout_select_coupon_layer_body_area">
                                <div class="checkout_select_coupon_layer_display_area" v-if="CheckoutSelectCouponLayerObj.display_coupon.length > 0">

                                    <div class="coupon_select_area">

                                        <div class="coupon_select_option_div"
                                             v-for="(coup, index) in CheckoutSelectCouponLayerObj.display_coupon"
                                             :key="index"
                                             :class="{isSelect : CheckCouponLayerIsDisplaySelect(coup), notAvailable : !CheckCouponLayerIsAvailable(coup)}"
                                             >
                                            <div class="total_coupon_box_div">
                                                <div class="total_coupon_box_text">x{{coup.couponList.length}}</div>
                                            </div>
                                            <div class="coupon_select_option_info_div" >
                                                <div class="coupon_select_option_title_div">{{coup['gtCoupon_Name' + getItemSubfix()]}}</div>
                                                <div class="coupon_select_option_date_div">{{label['checkout_coupon_text_coupon_expiry_date']}}: {{$root.writeDisplayDateFormat(coup['gtCouponStartDateString'])}} - {{$root.writeDisplayDateFormat(coup['gtCouponExpiryDateString'])}}</div>
                                                <div class="coupon_select_option_remark_div" v-html="coup['gtCoupon_Remark' + getItemSubfix()]" v-if="coup['gtCoupon_Remark' + getItemSubfix()] != ''"></div>
                                                
                                                <div class="tnc_qty_div display_desktop isflex">
                                                    <div class="tnc_div">
                                                        <div class="tnc_div_text" @click="openCouponTNC(coup)">{{label['checkout_coupon_text_tnc']}}</div>
                                                    </div>
                                                    <div class="qty_div">
                                                        <div class="tag_qty_select">
                                                            <div class="tag_icon min" :class="{'disable' : coup.selectQty <= 0}" @click="couponSelectTagQtyAdd(coup,'min')"></div>
                                                            <div class="tag_qty">{{coup.selectQty}}</div>
                                                            <div class="tag_icon plus" :class="{'disable' : (coup.selectQty >= coup.gtCoupon_maxUse || coup.selectQty >= coup.couponList.length)}" @click="couponSelectTagQtyAdd(coup,'add')"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="coupon_select_option_img_div" v-if="coup['gtCoupon_Image' + getItemSubfix()] != ''">
                                                <div class="coupon_select_option_img">
                                                    <img :src="coup['gtCoupon_Image' + getItemSubfix()]" align="absmiddle" />
                                                </div>
                                            </div>

                                            <div class="tnc_qty_div display_responsive isflex">
                                                <div class="tnc_div">
                                                    <div class="tnc_div_text" @click="openCouponTNC(coup)">{{label['checkout_coupon_text_tnc']}}</div>
                                                </div>
                                                <div class="qty_div">
                                                    <div class="tag_qty_select">
                                                        <div class="tag_icon min" :class="{'disable' : coup.selectQty <= 0}" @click="couponSelectTagQtyAdd(coup,'min')"></div>
                                                        <div class="tag_qty">{{coup.selectQty}}</div>
                                                        <div class="tag_icon plus" :class="{'disable' : (coup.selectQty >= coup.gtCoupon_maxUse || coup.selectQty >= coup.couponList.length)}" @click="couponSelectTagQtyAdd(coup,'add')"></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>                                        

                                    </div>

                                </div>
                                <div class="checkout_select_coupon_layer_display_area" v-if="CheckoutSelectCouponLayerObj.display_coupon.length <= 0">
                                    {{label['checkout_order_use_coupon_layer_no_coupon']}}
                                </div>
                            </div>
                        </div>   
                        <div class="checkout_select_coupon_layer_confirm_area">
                            <div class="checkout_select_coupon_layer_confirm_btn" @click="OrderCouponLayerEditConfirm()">{{label['checkout_order_use_coupon_layer_confirm_text']}}</div>
                        </div>
                    </div>

                </div>
            </div>
        </transition>
        <!-- checkout select coupon layer end -->

    </div>
</template>
 
<script>
    import Modal from "../components/Modal.vue";

    export default {
        data() {
            return {
                isCheckoutPage: this.$root.info.currentPathName == "/preview" ? false : true,
                isCheckoutPageCount: 0,
                isOpenHowToGetThere: false,
                isOpenCheckoutTNC: false,
                checkoutTNCContent: "",
                isTNCPageBodyFix: true,
                isTickCheckoutTNC: false,

                payMethod: {
                    code: "",
                    name1: "",
                    name2: "",
                    name3: "",
                    image: ""
                },
                payMethodList: [
                    {
                        code: "",
                        name1: "",
                        name2: "",
                        name3: "",
                        image: ""
                    }
                ],

                CheckoutSelectCouponLayerObj: {
                    showCheckoutSelectCouponLayer: false,
                    coupon_list: [],
                    select_coupon: [],
                    use_coupon: [],
                    display_coupon: []
                },

                UseDiscountCodeObj: {
                    inUse: false,
                    codeUse: "",
                    isError: false
                }

            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            order() {
                return this.$root.info.order;
            },
            event() {
                return this.order.eventObj;
            },            
            selectEventSessionDateTime() {
                var app = this;
                var display_text = "";
                $.each($(app.order.orderSession), function (key, tag) {
                    display_text = display_text + (display_text == "" ? "" : "<br/>") + (app.$root.writeDisplayDateFormat(tag.eventDate) + " " + app.$root.sessionTimeFormat(tag.eventStartTime) + " - " + app.$root.sessionTimeFormat(tag.eventEndTime)) + app.$root.selectSessionSessionRemarkDisplay(tag, true);
                });
                return display_text;
            },
            selectEventQuantity() {
                var app = this;
                var display_text = "";
                $.each($(this.order.orderPriceTag), function (key, tag) {
                    display_text = display_text + (display_text == "" ? "" : "<br/>") + app.$root.writePriceTagName(tag) + " x " + tag.qty;
                });
                return display_text;
            },            
            selectEventLanguageDisplay() {
                var app = this;
                var languageDisplay = "";
                $.each(this.event.language, function (key, value) {
                    if (app.info.lang == "tc" || app.info.lang == "sc") {
                        languageDisplay = languageDisplay + (languageDisplay == "" ? "" : "、") + value.languageName;
                    }
                    else {
                        languageDisplay = languageDisplay + (languageDisplay == "" ? "" : ", ") + value.languageName;
                    }
                });
                /*
                if (languageDisplay == "")
                    languageDisplay = this.label['event_common_text_language_NotSpecified'];
                */
                return languageDisplay;
            }
        },
        components: { Modal },
        watch: {
            '$root.info.lang': function (lang) {
                this.ReCheckEventOrder();
            },
            '$route': function (to, from) {
                if (to.path === `/` + this.info.lang + '/preview') {
                    this.isCheckoutPage = false;
                    this.$root.getCurrentPathName();
                    this.isCheckoutPageCount++;
                } else if (to.path === `/` + this.info.lang + '/checkout') {
                    this.isCheckoutPage = true;
                    this.$root.getCurrentPathName();
                    this.isCheckoutPageCount++;
                }
            },
            '$root.info.member': function (member) {
                if (member == null) {
                    //this.$root.ReloadCurrentPage();
                    this.$router.push(`/` + this.info.lang + `/`);
                }
            }
        },
        beforeCreate() {
            // check history can forward
            try {
                //window.history.forward();
            } catch (e) {}
        },
        created() {
            console.log("this.isCheckoutPage", this.isCheckoutPage);
            
            this.$root.getCurrentPathName();
            if (this.info.member != null) {

                if (this.$root.info.order) {
                    console.log("this.$root.info.order", this.$root.info.order);
                    var app = this;
                    this.info.loading = false;

                    this.payMethod = this.payMethodList[0];                    

                    app.info.loading = true;
                    $.when(
                        app.$root.wsGet(app.info.wsUrl + "/Order/GetPaymentTypeList?device=" + (app.info.order_temp_info.order_device == "web" ? "" : app.info.order_temp_info.order_device), app.$root.info.lang, function (data) {
                            if (data.status == 0) {

                                app.payMethodList = data.paymentTypeList;
                                if (app.payMethodList.length > 0) {
                                    //app.setPayMethod(app.payMethodList[0]);
                                    app.setFirstPayMethod();
                                }
                                else {
                                    app.setPayMethod(undefined);
                                }

                            }
                            else {
                                app.setPayMethod(undefined);
                            }
                        })
                    ).then(function () {
                        app.info.loading = false;
                    });


                    this.checkCanSubmit();
                    if (!this.canSubmitOrder && !this.isCheckoutPage) {
                        this.$router.back(-1);
                    }

                    this.OrderCouponEditLayerInit();
                    this.CartCheckoutDiscountCodeInit();                    
                } else {
                    this.$router.replace(`/` + this.info.lang + "/");
                }

            }
            else {
                this.$router.replace(`/` + this.info.lang + "/");
            }
        },
        destroyed() {
            this.$root.setGoBackAction();
        },
        mounted() {
            // on widow back
            /*
            var app = this;
            window.onpopstate = function (event) {
                app.checkoutPageBack();
            };
            */
        },
        methods: {
            checkoutPageBack() {
                if (this.isCheckoutPage) {
                    this.$router.back(-1);
                }
                else {
                    this.$router.back(-1);
                }
            },
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            CouponDiscountCodeLabel() {
                if (this.info.enableCouponCode) {
                    return this.label['checkout_text_coupon_discountcode'];
                }
                else {
                    return this.label['checkout_text_discountcode'];
                }
            },
            
            setPayMethod(pay) {
                var app = this;
                if (pay != undefined) {
                    if (app.checkPayMethodInCoupon(pay)) {
                        app.payMethod = pay;
                        app.checkCanSubmit();
                    }
                }
                else {
                    app.payMethod = pay;
                    app.checkCanSubmit();
                }
            },
            setFirstPayMethod() {
                var app = this;
                $.each($(app.payMethodList), function (key, pay) {
                    if (app.checkPayMethodInCoupon(pay)) {
                        app.payMethod = pay;
                        app.checkCanSubmit();
                        return false;
                    }
                });
            },
            getPayMethodlabel() {
                if (this.payMethod == undefined) {
                    return "";
                } else {
                    return this.payMethod["name" + this.getItemSubfix()];
                }
            },

            checkCanSubmit(isAlert) {
                this.canSubmitOrder = this.checkCanSubmitReturn(isAlert);
            },
            checkCanSubmitReturn(isAlert) {
                if (this.isTickCheckoutTNC) {
                    if (this.payMethod != undefined) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (isAlert)
                        this.$root.alert(this.label['checkout_text_please_confirm_tnc']);

                    return false;
                }
            },
            checkoutBookNowClick() {
                this.checkCanSubmit(true);
                if (this.isCheckoutPage) {
                    
                    if (this.canSubmitOrder) {
                        if (this.payMethod == undefined) return;
                        //this.$router.push(`/` + this.info.lang + "/preview"); // paySubmit directly without preview order 20241007

                        console.log("this.$root.info.order", this.$root.info.order);
                        this.paySubmit();
                    }

                }
                else {
                    if (this.canSubmitOrder) {
                        console.log("this.$root.info.order", this.$root.info.order);
                        this.paySubmit();
                    }
                    else {
                        this.$router.back(-1);
                    }
                }
            },

            checkPayMethodInCoupon(pay) {
                var re = false;

                if (this.order.orderCoupon != undefined) {
                    var checkCount = 0;
                    $.each($(this.order.orderCoupon), function (key, c) {
                        if (c.gtCoupon_Criteria != undefined && c.gtCoupon_Criteria["paymentMethod"].length > 0) {
                            if (checkValueInArray(c.gtCoupon_Criteria["paymentMethod"], pay.code)) {
                                re = true;
                                return false;
                            }
                        }
                        else {
                            checkCount++;
                        }
                    });
                    
                    if (this.order.orderCoupon.length == checkCount) {
                        re = true;
                    }
                }
                else {
                    re = true;
                }

                return re;
            },
            
            paySubmit() {
                /*
                if (this.info.member != null) {
                */
                    if (this.canSubmitOrder) {

                        if (this.payMethod == undefined) return;
                        if (this.order.finalPrice <= 0) {
                            this.payMethod = {
                                code: "",
                                name1: "",
                                name2: "",
                                name3: "",
                                image: ""
                            };
                        }
                        if (this.order.submitWaitingList) {
                            this.payMethod = {
                                code: "",
                                name1: "",
                                name2: "",
                                name3: "",
                                image: ""
                            };
                        }

                        var app = this;
                        var gathis = this;

                        //submit payment
                        app.info.loading = true;

                        var orderCreateJson = {
                            "eventId": app.event.eventId,
                            "sessionId": app.order.orderSession.at(-1).sessionId,
                            "priceTag": [],
                            "couponUse": (app.CheckoutSelectCouponLayerObj.use_coupon.length > 0 ? app.CheckoutSelectCouponLayerObj.use_coupon : []),
                            "discountCode": (app.UseDiscountCodeObj.inUse ? app.UseDiscountCodeObj.codeUse : ""),
                            "paymentType": app.payMethod.code,
                            "device": app.info.order_temp_info.order_device,
                            "submitWaitingList": app.order.submitWaitingList,
                            "reSubmit": app.order.allowReSubmit,
                            "reSubmitOrder": (app.order.allowReSubmit ? app.order.orderCode : "")
                        };
                        $.each($(app.order.orderPriceTag), function (key, tag) {
                            orderCreateJson.priceTag.push({ "priceTagId": tag.priceTagId, "qty": tag.qty });
                        });
                        console.log("orderCreateJson", orderCreateJson);
                        
                        $.ajax({
                            type: "POST",
                            headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                            url: app.info.wsUrl + "/Order/CreateEventOrder",
                            contentType: "application/json",
                            data: JSON.stringify(orderCreateJson),
                            dataType: "json",
                            success: (data) => {
                                console.log("CreateEventOrder", data);
                                
                                if (data.status == 0) {
                                    app.$root.inCompletePaymentObj.noneInComplete = false;
                                    
                                    gathis.$root.NFGA_FillParamCB(function () {

                                        if (data.actionType == "complete") {
                                            app.$root.removeOrderData();
                                            app.info.orderResult = data.orderCore;
                                            app.$router.push(`/` + app.info.lang + "/confirmation");
                                        }
                                        else if (data.actionType == "waiting") {
                                            app.$root.removeOrderData();
                                            app.info.orderResult = data.orderCore;
                                            app.$router.push(`/` + app.info.lang + "/confirmation");
                                        }
                                        else if (data.actionType == "payment") {
                                            //window.setTimeout(function () { window.history.go(1); }, 1000); // for checking window back
                                            //window.setInterval(function () { window.history.go(1); }, 1000); // for checking window back
                                            window.setTimeout(function () { app.$root.ReloadCurrentPage(); }, 5000); // for checking window back

                                            app.$root.removeOrderData(); // clear info.order before going to payment page

                                            var url = data.paymentUrl;
                                            if (data.paymentAction == "post") {
                                                $('<form method="POST">').attr("action", url).appendTo('body').submit();
                                            }
                                            else {
                                                if (url.indexOf("http") != 0) url = app.info.wsHost + url;
                                                window.location = url;
                                            }
                                            return;
                                        }

                                    },
                                    "NFGA_checkouts", "'" + data.orderCore.eventObj.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + data.orderCore.eventObj.mall.NFMallID + "'", "'" + data.orderCore.eventObj.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + data.orderCode +"'");
                                    
                                } else {

                                    app.info.loading = false;
                                    if (data.status == 1) {                                        
                                        app.$root.alert(app.label['checkout_error_text_event_not_found']);
                                        app.$router.replace(`/` + app.info.lang + "/");
                                        app.$root.removeOrderData();
                                    }
                                    else if (data.status == 2) {
                                        app.$root.alert(app.label['checkout_error_text_quota_is_over']);
                                        app.$root.goEventDetailsPage(app.event);
                                        app.$root.removeOrderData();
                                    }
                                    else if (data.status == 7) {
                                        app.$root.alert(app.label['checkout_error_text_limitquota_is_over']);
                                        app.$root.goEventDetailsPage(app.event);
                                        app.$root.removeOrderData();
                                    }
                                    else if (data.status == 4) {
                                        app.$root.alert(app.label['checkout_order_use_discount_code_error_msg_text_fail_use_discount_code']);
                                    }
                                    else if (data.status == 5) {
                                        var errorCode = data.detail.substring(0, 4);
                                        if (app.label['checkout_error_text_error_on_using_coupon.' + errorCode] != undefined) {
                                            app.$root.alert(app.label['checkout_error_text_error_on_using_coupon.' + errorCode]);
                                        }
                                        else {
                                            app.$root.alert(app.label['checkout_error_text_error_on_using_coupon']);
                                        }    
                                    }
                                    else {

                                        if (data.status == 98) {
                                            app.$root.removeInfoMemberData();
                                            app.$root.ReloadCurrentPage();
                                        } else {
                                            app.$root.alert(data.detail);
                                        }

                                    }

                                }
                                
                            }
                        });
                        
                    }
                /*
                }
                else {
                    this.page_after_login = "/checkout";
                    self.$router.push("/guestlogin");
                }
                */
            },

            openHowToGetThere() {
                this.isOpenHowToGetThere = true;
                this.$root.setBodyOverflow(true);
            },
            closeHowToGetThere() {
                this.isOpenHowToGetThere = false;
                this.$root.setBodyOverflow(false);
            },
            openCheckoutTNC() {
                this.isOpenCheckoutTNC = true;
                this.$root.setBodyOverflow(true);
                /*
                $.ajax({
                    type: "GET",
                    url: "/files/stand_alone_page/" + this.info.lang + "/checkout_tnc.htm",
                    dataType: "html",
                    success: (data) => {
                        this.checkoutTNCContent = data;
                    }
                }).catch(function () {
                });
                */
                this.checkoutTNCContent = this.event.eventTNC;
            },
            closeCheckoutTNC() {
                this.isOpenCheckoutTNC = false;

                if (this.isTNCPageBodyFix)
                    this.$root.setBodyOverflow(false);

                this.checkoutTNCContent = "";
                this.isTNCPageBodyFix = true;
            },
            tickCheckoutTNC() {
                if (this.isTickCheckoutTNC)
                    this.isTickCheckoutTNC = false;
                else
                    this.isTickCheckoutTNC = true;
            },
            ReCheckEventOrder() {
                var app = this;
                var priceTag = [];
                $.each($(app.order.orderPriceTag), function (key, tag) {
                    priceTag.push({ "priceTagId": tag.priceTagId, "qty": tag.qty });
                });

                app.$root.CheckEventOrder(app.event.eventId, app.order.orderSession.at(-1).sessionId, priceTag, app.CheckoutSelectCouponLayerObj.use_coupon, app.UseDiscountCodeObj.codeUse, app.payMethod.code, app.info.order_temp_info.order_device, app.order.submitWaitingList, app.order.allowReSubmit, app.order.orderCode,  
                    function (data) {

                        if (data.status == 0) {
                            app.$root.setOrderData(data.orderCore, app.order.submitWaitingList);
                        } else {

                            if (data.status == 1) {
                                app.$root.alert(app.label['checkout_error_text_event_not_found']);
                                app.$router.replace(`/` + app.info.lang + "/");
                                app.$root.removeOrderData();
                            }
                            else if (data.status == 2) {
                                app.$root.alert(app.label['checkout_error_text_quota_is_over']);
                                app.$router.replace(`/` + app.info.lang + "/");
                                app.$root.removeOrderData();                     
                            }
                            else if (data.status == 7) {
                                app.$root.alert(app.label['checkout_error_text_limitquota_is_over']);
                                app.$router.replace(`/` + app.info.lang + "/");
                                app.$root.removeOrderData();                     
                            }
                            else if (data.status == 6) {
                                app.$root.alert(app.label['checkout_error_text_no_permission_join_event']);
                                app.$router.replace(`/` + app.info.lang + "/");
                                app.$root.removeOrderData();                     
                            }
                            else {
                                if (data.status == 98) {
                                    app.$root.removeInfoMemberData();
                                    app.$root.ReloadCurrentPage();
                                } else {
                                    app.$root.alert(data.detail);
                                }
                            }

                        }
                        
                    }
                );
            },

            /* coupon start */
            checkCanUseCoupon() {
                if (!this.UseDiscountCodeObj.inUse) {
                    return true;
                }
                else {
                    return false;
                }
            },
            OrderCouponEditLayerInit() {
                if (this.order.orderCoupon != undefined) {
                    this.CheckoutSelectCouponLayerObj.use_coupon = JSON.parse(JSON.stringify(this.order.orderCoupon));
                    this.CheckoutSelectCouponLayerObj.select_coupon = JSON.parse(JSON.stringify(this.CheckoutSelectCouponLayerObj.use_coupon));
                }
                else {
                    this.CheckoutSelectCouponLayerObj.use_coupon = [];
                    this.CheckoutSelectCouponLayerObj.select_coupon = [];
                }
            },
            OpenOrderCouponEditLayer() {
                if (this.checkCanUseCoupon()) {
                    var app = this;
                    app.OrderCouponEditLayerInit();

                    var priceTag = [];
                    $.each($(app.order.orderPriceTag), function (key, tag) {
                        priceTag.push({ "priceTagId": tag.priceTagId, "qty": tag.qty });
                    });
                    var orderCreateJson = {
                        "eventId": app.event.eventId,
                        "sessionId": app.order.orderSession.at(-1).sessionId,
                        "priceTag": priceTag,
                        "paymentType": app.payMethod.code,
                        "device": app.info.order_temp_info.order_device
                    };

                    // get coupon list                    
                    app.info.loading = true;
                    $.ajax({
                        type: "POST",
                        headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                        url: app.info.wsUrl + "/Member/GetMemberCoupon",
                        async: true,
                        contentType: "application/json",
                        data: JSON.stringify(orderCreateJson),
                        dataType: "json",
                        success: (data) => {
                            console.log("GetMemberCoupon", data);
                            this.info.loading = false;

                            //this.CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer = true;
                            //this.$root.setBodyOverflow(true);
                        
                            if (data.status == 0) {                                    
                                this.CheckoutSelectCouponLayerObj.coupon_list = data.coupon;
                                /*
                                $.each(this.CheckoutSelectCouponLayerObj.coupon_list, (i, c) => {
                                    c.inUse = this.CheckCouponLayerIsSelect(c);
                                });
                                multiSort(this.CheckoutSelectCouponLayerObj.coupon_list, { "inUse": "desc", "isAvailable": "desc", "gtCouponExpiryDateString": "asc", "gtCouponCode": "asc", "gtCouponId": "asc" });
                                */
                                this.SetCouponDisplayList();
                                console.log("display_coupon", app.CheckoutSelectCouponLayerObj.display_coupon);


                                // open select coupon layer
                                this.CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer = true;
                                this.$root.setBodyOverflow(true);
                            } else {
                                if (data.status == 98) {
                                    app.$root.removeInfoMemberData();
                                    app.$root.ReloadCurrentPage();
                                } else {
                                    app.$root.alert(data.detail);
                                }
                            }
                        
                        },
                    });
                }
            },
            SetCouponDisplayList() {
                var app = this;
                app.CheckoutSelectCouponLayerObj.display_coupon = [];
                $.each(app.CheckoutSelectCouponLayerObj.coupon_list, (i, c) => {
                    c.inUse = app.CheckCouponLayerIsSelect(c);

                    //if (c.isAvailable) {
                        var cidx = app.CheckCouponIsDisplay(c);
                        if (cidx < 0) {
                            c.selectQty = 0;
                            c.couponList = [];
                            c.couponList.push(JSON.parse(JSON.stringify(c)));
                            app.CheckoutSelectCouponLayerObj.display_coupon.push(JSON.parse(JSON.stringify(c)));
                        }
                        else {
                            app.CheckoutSelectCouponLayerObj.display_coupon[cidx].couponList.push(JSON.parse(JSON.stringify(c)));
                        }
                    //}
                });
                //multiSort(app.CheckoutSelectCouponLayerObj.display_coupon, { "isAvailable": "desc", "gtCouponExpiryDateString": "asc", "gtCouponCode": "asc", "gtCouponId": "asc" });

                app.CheckCouponSelectQty();
            },
            CheckCouponIsDisplay(coupon_object) {
                var cidx = -1;
                $.each(this.CheckoutSelectCouponLayerObj.display_coupon, (i, c) => {
                    if (c.gtCouponId2 == coupon_object.gtCouponId2) {
                        cidx = i;
                        return false;
                    }
                });
                return cidx;
            },
            CheckCouponSelectQty() {
                var app = this;

                $.each(app.CheckoutSelectCouponLayerObj.display_coupon, (i, a) => {
                    a.selectQty = 0;
                    $.each(a.couponList, (j, b) => {
                        if (app.CheckCouponLayerIsSelect(b)) {
                            a.selectQty++;
                        }
                    });
                });
            },
            CloseOrderCouponEditLayer() {
                this.CheckoutSelectCouponLayerObj.showCheckoutSelectCouponLayer = false;
                this.CheckoutSelectCouponLayerObj.select_coupon = [];

                this.$root.setBodyOverflow(false);
            },
            CouponEditLayerChangeType(layer_type) {
                this.CheckoutSelectCouponLayerObj.display_tag = layer_type;
            },
            OrderCouponLayerEditConfirm() {
                var app = this;
                
                // call api to update cart coupon use start           
                var priceTag = [];
                $.each($(app.order.orderPriceTag), function (key, tag) {
                    priceTag.push({ "priceTagId": tag.priceTagId, "qty": tag.qty });
                });


                //app.$root.CheckEventOrder(app.event.eventId, app.order.orderSession.at(-1).sessionId, priceTag, app.CheckoutSelectCouponLayerObj.select_coupon, (data.orderCore.orderDiscountCode.length > 0 ? data.orderCore.orderDiscountCode[0].discountCode : ""), app.payMethod.code, app.info.order_temp_info.order_device, app.order.submitWaitingList, app.order.allowReSubmit, app.order.orderCode, app.OrderCouponLayerEditConfirmCb);
                app.$root.CheckEventOrder(app.event.eventId, app.order.orderSession.at(-1).sessionId, priceTag, app.CheckoutSelectCouponLayerObj.select_coupon, "", app.payMethod.code, app.info.order_temp_info.order_device, app.order.submitWaitingList, app.order.allowReSubmit, app.order.orderCode, app.OrderCouponLayerEditConfirmCb);
                // coupon and discount code cannot use together
                // call api to update cart coupon use end
                
                //this.CloseOrderCouponEditLayer(); // call close layer after callback
            },
            OrderCouponLayerEditConfirmCb(data) {
                console.log("data", data);
                var app = this;

                if (data.status == 0) {
                    var couponCode = "";
                    $.each(app.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        couponCode = couponCode + (couponCode != "" ? "," : "") + c.gtCouponId;
                    });
                    var gathis = this;
                    gathis.$root.NFGA_FillParam("NFGA_Apply", "'" + app.event.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.event.mall.NFMallID + "'", "'" + app.event.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + couponCode +"'", "''");

                    app.$root.setOrderData(data.orderCore, app.order.submitWaitingList);
                    app.OrderCouponEditLayerInit(); // reset coupon status
                    app.CartCheckoutDiscountCodeInit(); // reset discount code status
                } else {

                    if (data.status == 1) {
                        app.$root.alert(app.label['checkout_error_text_event_not_found']);
                        app.$router.replace(`/` + app.info.lang + "/");
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 2) {
                        app.$root.alert(app.label['checkout_error_text_quota_is_over']);
                        app.$root.goEventDetailsPage(app.event);
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 7) {
                        app.$root.alert(app.label['checkout_error_text_limitquota_is_over']);
                        app.$root.goEventDetailsPage(app.event);
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 5) {
                        var errorCode = data.detail.substring(0, 4);
                        if (app.label['checkout_error_text_error_on_using_coupon.' + errorCode] != undefined) {
                            app.$root.alert(app.label['checkout_error_text_error_on_using_coupon.' + errorCode]);
                        }
                        else {
                            app.$root.alert(app.label['checkout_error_text_error_on_using_coupon']);
                        }                        
                    }
                    else {

                        if (data.status == 98) {
                            app.$root.removeInfoMemberData();
                            app.$root.ReloadCurrentPage();
                        } else {
                            app.$root.alert(data.detail);
                        }

                    }

                }

                this.CloseOrderCouponEditLayer();
            },
            CheckCouponLayerIsSelect(coupon_object) {
                var cidx = -1;
                $.each(this.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                    if (c.gtCouponId == coupon_object.gtCouponId) {
                        cidx = i;
                        return false;
                    }
                });
                if (cidx >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            CheckCouponLayerIsDisplaySelect(coupon_object) {
                var cidx = -1;
                $.each(this.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                    if (c.gtCouponId2 == coupon_object.gtCouponId2) {
                        cidx = i;
                        return false;
                    }
                });
                if (cidx >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            CheckCouponLayerIsAvailable(coupon_object) {
                var app = this;
                var re = false;

                if (coupon_object.isAvailable) {
                    re = true;
                }
                else {
                    /*
                    var temp_coupon = [];
                    $.each(app.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        
                        // check coupon can use with other discount

                        
                    });
                    */
                    re = false;
                }

                return re;
            },
            CouponLayerSelectCoupon(coupon_object) {
                if (coupon_object.isAvailable) {

                    // check current coupon
                    var cidx = -1;
                    $.each(this.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        if (c.gtCouponId == coupon_object.gtCouponId) {
                            cidx = i;
                            return false;
                        }
                    });
                     
                    if (cidx >= 0) {
                        // remove select coupon
                        this.CheckoutSelectCouponLayerObj.select_coupon.splice(cidx, 1);
                    } else {

                        // check coupon alow muti
                        if (coupon_object.gtCoupon_allowMuti) {
                        }
                        else {
                            var temp_c = null;
                            for (var x = this.CheckoutSelectCouponLayerObj.select_coupon.length; x > 0; x--) {
                                temp_c = this.CheckoutSelectCouponLayerObj.select_coupon[x-1];
                                if (!temp_c.gtCoupon_allowMuti) {
                                    this.CheckoutSelectCouponLayerObj.select_coupon.splice(x-1, 1);
                                }
                            }
                        }

                        this.CheckoutSelectCouponLayerObj.select_coupon.push(coupon_object);
                    }                    
                }
            },
            RemoveCouponUseBtnClick() {
                this.CheckoutSelectCouponLayerObj.use_coupon = [];
                this.CheckoutSelectCouponLayerObj.select_coupon = [];
                this.OrderCouponLayerEditConfirm();
            },
            openCouponTNC(coup) {
                this.isOpenCheckoutTNC = true;
                //this.$root.setBodyOverflow(true);
                this.isTNCPageBodyFix = false;
                this.checkoutTNCContent = coup['gtCoupon_TNC' + this.getItemSubfix()];
            },            
            couponSelectTagQtyAdd(coupon_object, type) {
                if (coupon_object.isAvailable) {
                    var app = this;

                    // check contains same coupon group
                    var cidx = -1;
                    $.each(app.CheckoutSelectCouponLayerObj.select_coupon, (i, c) => {
                        if (c.gtCouponId2 == coupon_object.gtCouponId2) {
                            cidx = i;
                            return false;
                        }
                    });

                    if (type == "add") {

                        // remove all not allow muti coupon
                        if (coupon_object.gtCoupon_allowMuti) {
                        }
                        else {
                            var temp_c = null;
                            for (var x = app.CheckoutSelectCouponLayerObj.select_coupon.length; x > 0; x--) {
                                temp_c = app.CheckoutSelectCouponLayerObj.select_coupon[x - 1];
                                if (!temp_c.gtCoupon_allowMuti) {

                                    if (cidx >= 0) {
                                        if (temp_c.gtCouponId2 != coupon_object.gtCouponId2) {
                                            this.CheckoutSelectCouponLayerObj.select_coupon.splice(x - 1, 1);
                                        }
                                    }
                                    else {
                                        this.CheckoutSelectCouponLayerObj.select_coupon.splice(x - 1, 1);
                                    }
                                }
                            }
                        }

                        // update current qty
                        app.CheckCouponSelectQty();
                        var selectCoupon = null;
                        $.each(app.CheckoutSelectCouponLayerObj.display_coupon, (i, c) => {
                            if (c.gtCouponId2 == coupon_object.gtCouponId2) {
                                selectCoupon = c;
                                return false;
                            }
                        });

 
                        // check can add coupon
                        if ((selectCoupon.selectQty + 1) <= selectCoupon.gtCoupon_maxUse && (coupon_object.selectQty + 1) <= selectCoupon.couponList.length) {
                            var addCoupon = selectCoupon.couponList[selectCoupon.selectQty];
                            app.CheckoutSelectCouponLayerObj.select_coupon.push(addCoupon);
                        }
                    }
                    else {

                        // remove same group coupon
                        if (cidx >= 0) {
                            var temp_c = null;
                            for (var x = app.CheckoutSelectCouponLayerObj.select_coupon.length; x > 0; x--) {
                                temp_c = app.CheckoutSelectCouponLayerObj.select_coupon[x - 1];
                                if (temp_c.gtCouponId2 == coupon_object.gtCouponId2) {
                                    app.CheckoutSelectCouponLayerObj.select_coupon.splice(x - 1, 1);
                                    break;
                                }
                            }
                        }

                    }

                    // update current qty
                    app.CheckCouponSelectQty();
                }
            },
            CouponRemovePreview(idx) {
                this.CheckoutSelectCouponLayerObj.use_coupon.splice(idx, 1);
                this.ReCheckEventOrder();
                this.checkoutPageBack();
            },
            /* coupon end */

            /* discount code start */
            checkCanUseDiscountCode() {
                if (this.CheckoutSelectCouponLayerObj.use_coupon.length <= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            CartCheckoutDiscountCodeInit() {
                if (this.order.orderDiscountCode != undefined && this.order.orderDiscountCode.length > 0) {
                    this.UseDiscountCodeObj.inUse = true;
                    this.UseDiscountCodeObj.codeUse = this.order.orderDiscountCode[0].discountCode;
                    this.UseDiscountCodeObj.isError = false;
                }
                else {
                    this.UseDiscountCodeObj.inUse = false;
                    this.UseDiscountCodeObj.codeUse = "";
                    this.UseDiscountCodeObj.isError = false;
                }                
            },
            UseDiscountCodeCheckoutBtnClick() {
                if (this.checkCanUseDiscountCode()) {
                    var discountCode_obj = this.$el.querySelector("#checkout_cart_discount_code");
                    var discountCode_val = discountCode_obj.value.replace(/ /g, '');

                    if (discountCode_val.length > 0) {
                        this.UseDiscountCodeCheckEventOrder(discountCode_val);
                    }
                    else {
                        discountCode_obj.value = discountCode_val;
                        this.UseDiscountCodeObj.isError = false;
                    }
                }
            },
            UseDiscountCodeCheckEventOrder(discountCode_val) {
                var app = this;
                // check discount code by calling CheckEventOrder Api start
                var priceTag = [];
                $.each($(app.order.orderPriceTag), function (key, tag) {
                    priceTag.push({ "priceTagId": tag.priceTagId, "qty": tag.qty });
                });
                //app.$root.CheckEventOrder(app.event.eventId, app.order.orderSession.at(-1).sessionId, priceTag, (data.orderCore.orderCoupon.length > 0 ? data.orderCore.orderCoupon : []), discountCode_val, app.payMethod.code, app.info.order_temp_info.order_device, app.order.submitWaitingList, app.order.allowReSubmit, app.order.orderCode, app.UseDiscountCodeCheckEventOrderCb);
                app.$root.CheckEventOrder(app.event.eventId, app.order.orderSession.at(-1).sessionId, priceTag, [], discountCode_val, app.payMethod.code, app.info.order_temp_info.order_device, app.order.submitWaitingList, app.order.allowReSubmit, app.order.orderCode, app.UseDiscountCodeCheckEventOrderCb);
                // coupon and discount code cannot use together
                // check discount code by calling CheckEventOrder Api end
            },
            UseDiscountCodeCheckEventOrderCb(data) {
                console.log("data", data);
                var app = this;

                if (data.status == 0) {                    
                    app.$root.setOrderData(data.orderCore, app.order.submitWaitingList);
                    app.OrderCouponEditLayerInit(); // reset coupon status
                    //app.CartCheckoutDiscountCodeInit(); // reset discount code status

                    if (data.orderCore.orderDiscountCode != undefined) {
                        app.UseDiscountCodeObj.inUse = true;
                        app.UseDiscountCodeObj.codeUse = data.orderCore.orderDiscountCode[0].discountCode;
                        app.UseDiscountCodeObj.isError = false;
                    }
                    else {
                        app.UseDiscountCodeObj.inUse = false;
                        //app.UseDiscountCodeObj.codeUse = "";
                        app.UseDiscountCodeObj.isError = false;
                    }

                    var gathis = this;
                    gathis.$root.NFGA_FillParam("NFGA_Apply", "'" + app.event.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.event.mall.NFMallID + "'", "'" + app.event.mall.mallName.replace(/\'/g, "\\\'") + "'", "''", "'" + app.UseDiscountCodeObj.codeUse + "'");
                } else {

                    if (data.status == 1) {
                        app.$root.alert(app.label['checkout_error_text_event_not_found']);
                        app.$router.replace(`/` + app.info.lang + "/");
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 2) {
                        app.$root.alert(app.label['checkout_error_text_quota_is_over']);
                        app.$root.goEventDetailsPage(app.event);
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 7) {
                        app.$root.alert(app.label['checkout_error_text_limitquota_is_over']);
                        app.$root.goEventDetailsPage(app.event);
                        app.$root.removeOrderData();
                    }
                    else if (data.status == 4) {
                        app.UseDiscountCodeObj.isError = true;
                    }
                    else {

                        if (data.status == 98) {
                            app.$root.removeInfoMemberData();
                            app.$root.ReloadCurrentPage();
                        } else {
                            app.$root.alert(data.detail);
                        }

                    }

                }
            },
            RemoveDiscountCodeCheckoutBtnClick() {
                var app = this;

                // cal api remove discount code                
                //app.UseDiscountCodeObj.inUse = false;
                //app.UseDiscountCodeObj.codeUse = "";
                app.UseDiscountCodeCheckEventOrder("");
            },
            /* discount code end */

            
        },
    };
</script>

